module.exports = "/_next/static/pages/testing-environment/fbaf2bc712ee1d7de41b5028be56fd85.png";